import { Binding } from '@root/api/ump-plat-sdk-gateway'

export const binding = {
  bindingId: '3284F946F1364B95BD57CBC0C1C099B2',
  bindingType: 'MTS_ACCOUNT',
  title: 'Мой телефон',
  balance: 10384.0,
  image: 'https://pay.mts.ru/assets/images/paymentTools/emoneyAccount/',
  bankAccountNumber: '40914810410091867570',
} as Binding
